import './RegistrationPage.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { RegistrationFormContentType } from '../contentTypes';
import { Page } from './Page';

export interface RegistrationPageProps {}

export const RegistrationPage = (props: RegistrationPageProps) => {
  const content = b2x.useContent<RegistrationFormContentType>('REGISTRATION_FORM_CONTENT');

  return (
    <Page className="registration-page" grayBackground thingsToLoadBeforePageReady={[content]}>
      <Container>
        <b2x.Row className="justify-content-center">
          <b2x.Col size={{ lg: 9, xl: 7 }}>
            <div className="mb-4 text-center">
              <h1 className="text-uppercase  mb-3">{b2x.formatHtml(content?.body.title)}</h1>
              <p>{b2x.formatHtml(content?.body.subTitle)}</p>
            </div>
            <b2x.CustomerForm className="mb-4" />
          </b2x.Col>
        </b2x.Row>
      </Container>
    </Page>
  );
};
